import { Box, Drawer, IconButton, Skeleton } from '@mui/material';
import { IoClose } from 'react-icons/io5';
import { useNavigate } from 'react-router-dom';

export default function ChunkFormSkeleton() {
  const navigate = useNavigate();

  return (
    <Drawer
      anchor='right'
      open={true}
      onClose={() => navigate(-1)}
      sx={{
        '& .MuiDrawer-paper': {
          width: { xs: '100%', sm: 400, md: 600, lg: 1000 },
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          zIndex: 100001
        }
      }}
    >
      {/* Fixed Header Skeleton */}
      <Box
        sx={{
          px: 3,
          py: 2,
          borderBottom: '1px solid #DEDEDE',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          flexShrink: 0
        }}
      >
        <Skeleton variant='text' width={120} height={32} />
        <IconButton onClick={() => navigate(-1)} size='small'>
          <IoClose size={24} />
        </IconButton>
      </Box>

      {/* Form Content Skeleton */}
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        {/* Scrollable Content Skeleton */}
        <Box
          sx={{
            flex: 1,
            overflow: 'auto',
            p: 3
          }}
        >
          {/* QA Type Fields */}
          <Box>
            {/* Question Field */}
            <Skeleton variant='text' width={80} height={20} sx={{ mb: 1 }} />
            <Skeleton variant='rectangular' height={56} sx={{ borderRadius: 1 }} />

            {/* Answer Field */}
            <Skeleton variant='text' width={60} height={20} sx={{ mb: 1, mt: 2 }} />
            <Skeleton variant='rectangular' height={56} sx={{ borderRadius: 1 }} />
          </Box>

          {/* Alternative: Single Chunk Field */}
          <Box>
            <Skeleton variant='text' width={60} height={20} sx={{ mb: 1 }} />
            <Skeleton variant='rectangular' height={120} sx={{ borderRadius: 1 }} />
          </Box>
        </Box>

        {/* Fixed Footer Skeleton */}
        <Box
          sx={{
            px: 3,
            py: 2,
            borderTop: '1px solid #DEDEDE',
            display: 'flex',
            justifyContent: 'end',
            gap: 2,
            flexShrink: 0
          }}
        >
          <Skeleton variant='rectangular' width={80} height={40} sx={{ borderRadius: 1 }} />
          <Skeleton variant='rectangular' width={100} height={40} sx={{ borderRadius: 1 }} />
        </Box>
      </Box>
    </Drawer>
  );
}
